import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery, Avatar, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { List, Datagrid, TextField, FunctionField, SimpleList, usePermissions, useRefresh } from 'react-admin';
import { vehicleSvgs, hideMobileNumber, hideName, hideVehicleNumber } from "./sharedData";
import { useSelector, useDispatch } from "react-redux";
import config from './config.json';
import queryString from 'query-string';
import moment from "moment";
import { customTheme } from './customTheme';
import CustomExportButton from './components/CustomExportButton';
import CustomFilter from './components/CustomFilter';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import CustomDateTimePicker from './components/CustomDateTimePickerV2';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import CustomSearch from './components/CustomSearch';
import ShowTimePeriod from './components/ShowTimePeriod';
import PermitSummaryCard from './components/PermitSummaryCard'
import CustomDeleteButtonDashboardPath from './components/CustomDeleteButtonDashboardPath'

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    loaderContainer: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    asyncSelector: {
        display: "grid",
        gridAutoFlow: "column",
        justifyContent: "space-between",
        paddingRight: 5,
    },
    summaryCardContainer: {
        display: "grid",
    },
    timeFilterContainer: {
        alignItems: "center",
    },
    timeFilterButton: {
        marginLeft: "1%",
        width: "10%",
        minWidth: 85
    },
    searchParamsTitle: {
        fontSize: "1.05rem",
    },
    searchParams: {
        fontFamily: "Poppins-Regular",
        fontSize: "0.95rem",
    },
});

const renderVehicleType = (row) => (
    <div style={{ display: 'flex', alignItems: "center" }}>
        <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 8 }} alt={`${row.vehicle_type} icon`} />
        {/* row.vehicle_type_label */}
    </div>
);

const renderAction = action => {
    var color;
    switch (action) {
        case "RECHARGE": color = "#334d6e"; break;
        case "ISSUE": color = "#18cc69"; break;
        default: color = customTheme.palette.secondary.main;
    }

    return <div style={{ color }}>{action}</div>;
}
const renderActionForMob = action => {
    var color;
    switch (action) {
        case "RECHARGE": color = customTheme.palette.primary.main; break;
        case "ISSUE": color = "#18cc69"; break;
        default: color = customTheme.palette.secondary.main;
    }

    return <div style={{ color, display: "inline" }}>{action}</div>;
}
const renderAmount = (row, fieldName) => (row[fieldName] && !isNaN(row[fieldName]) ? `₹ ${parseFloat(row[fieldName])}` : "-");

const CATEGORY = "MONTHLY PASS PAYMENT SECTION"

export default function MonthlyPassPayment(props) {
    const { permissions } = usePermissions();
    const refresh = useRefresh();
    const eventTracker = UseAnalyticsEvent()
    const location = useLocation()
    const classes = useStyles();
    const vehicleNumber = useSelector(state => state.searchText);
    const dispatch = useDispatch();
    const listDataRef = useRef();

    //const notify = useNotify();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [limitDataRange] = useState(sessionStorage.getItem("limit_data_range") ? JSON.parse(sessionStorage.getItem("limit_data_range")) : {});
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    const currentParking = useSelector(state => state.monthlyPassParking);
    //const [vehicleTypes, setVehicleTypes] = React.useState([]);
    const [monthlyPassSummary, setMonthlyPassSummary] = React.useState({ data: null, loading: true, count: null });

    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [startDateTimeFilter, setStartDateTimeFilter] = useState(null);
    const [endDateTimeFilter, setEndDateTimeFilter] = useState(null);
    const [showTiles, setShowTiles] = useState(true)

    const zoneIds = currentParking && currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking && currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Vehicle Number", "Name", "Mobile"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    let filterTypesInitState = [

        {
            filterType: "Vehicle",
            dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Log",
            dataList: [{ name: "ISSUE", id: 1 }, { name: "RECHARGE", id: 2 }, { name: "APPROVAL", id: 3 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Payment Mode",
            dataList: [{ name: "CASH", id: 1 }, { name: "ONLINE", id: 2 }, { name: "APP", id: 3 }, { name: "CARD", id: 4 }, { name: "DIGITAL", id: 5 } ],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        }
    ]
    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    const filter = { ...settingFilterFormat, vehicle_number: vehicleNumber, start_time: startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "", end_time: endDateTimeFilter ? moment(endDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" } };
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
    const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

    const renderTime = time => {
        const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if (use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
    };
    const setCurrentParking = parking => {
        dispatch({
            type: "UPDATE_MONTHLY_PASS_PARKING",
            payload: {
                monthlyPassParking: parking,
            }
        });
    };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const setTimeFilters = () => {
        setStartDateTimeFilter(startDateTime);
        setEndDateTimeFilter(endDateTime);
    };

    const getExportFile = (fileType) => {
        const { current: { total, currentSort, filterValues } } = listDataRef
        const params = {
            filter: JSON.stringify({ ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/monthlyPassPayment?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute('download', `${currentParking && currentParking.name ? currentParking.name : "Monthly Pass Payments"}.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    const getPDF = () => {
        getExportFile("pdf");
    };

    React.useEffect(() => {
        eventTracker(CATEGORY, " MONTHLY PASS PAYMENTS LOGS")
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        setMonthlyPassSummary({ ...monthlyPassSummary, data: null, loading: true });
        fetch(`${config.HOST_NAME}/crm/v3/monthlyPassSummary?access_key_id=${filter.access_key}&parking_info_id=${filter.parking_info_id ? filter.parking_info_id : ""}&zone_id=${filter.zone_id ? filter.zone_id : ""}&start_time=${startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : ""}&end_time=${endDateTimeFilter ? moment(endDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : ""}&user_id=${sessionStorage.getItem("user_id")}&subType=Payments&vehicle_type=${settingFilterFormat.vehicle_type}&log_type=${settingFilterFormat.log_type}&payment_mode=${settingFilterFormat.payment_mode ? settingFilterFormat.payment_mode : undefined}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(responseJson => {
                if (responseJson.success) {
                    setMonthlyPassSummary({ loading: false, data: responseJson.data, count: Object.keys(responseJson.data.vehicleTypes).length });
                } else {
                    setMonthlyPassSummary({ ...monthlyPassSummary, loading: false });
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                setMonthlyPassSummary({ ...monthlyPassSummary, loading: false });
                notify('Error Fetching Monthly Pass Summary', 'warning')
            });

    }, [settingFilterFormat, startDateTimeFilter, endDateTimeFilter, currentParking]); // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        const queryParams = queryString.parse(props.location.search);
        if (queryParams.vehicle_number) {
            dispatch({
                type: "UPDATE_SEARCH_TEXT",
                payload: {
                    searchText: queryParams.vehicle_number,
                }
            });
        }
    }, [props]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Vehicle") {
                    values = { ...values, vehicle_type: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
                if (filterListValue[val].filterType === "Log") {
                    values = { ...values, log_type: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Payment Mode") {
                    values = { ...values, payment_mode: filterListValue[val].value ? filterListValue[val].value === "DIGITAL" ? "Digital" : filterListValue[val].value : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className={classes.list}>
            <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
                {showFilter &&
                    <ParkingSearchSelector
                        value={currentParking}
                        onChange={onParkingChange}
                        clearable={true}
                        // filter={{ feature_monthly_pass: 1 }}
                    />
                }
                {currentParking && currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>
            <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
                <CustomDateTimePicker
                    startDateTime={startDateTime}
                    setStartDateTime={setStartDateTime}
                    endDateTime={endDateTime}
                    setEndDateTime={setEndDateTime}
                    onChange={setTimeFilters}
                    limitDataRange={limitDataRange ? limitDataRange["monthlyPassPayment"] : null}
                />
                <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
                <CustomExportButton getCSV={getExcelFile} getPDF={getPDF} disabled={listDataRef.current && listDataRef.current.total === 0} />
            </div>
            <ShowTimePeriod startDateTimeFilter={startDateTime} endDateTimeFilter={endDateTime} showTiles={showTiles} setShowTiles={setShowTiles} />
            {currentParking && <>
                {showTiles && <div className={classes.summaryCardContainer} style={{ display: "grid", gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, justifyContent: "space-between", marginTop: 10 }}>
                    <PermitSummaryCard
                        title="Issue"
                        data={monthlyPassSummary.data}
                        getValue={data => data.issueCount}
                        getAmount={data => data.issueAmount ? `₹ ${data.issueAmount.toFixed(2)}` : `₹ 0`}
                        getDistributedLabels={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].issueCount > 0).map(type => data.vehicleTypes[type].name)}
                        getDistributedValues={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].issueCount > 0).map(type => data.vehicleTypes[type].issueCount)}
                        getDistributedAmount={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].issueAmount > 0).map(type => data.vehicleTypes[type].issueAmount)}
                        getDistributedIcons={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].issueCount > 0).map(type => vehicleSvgs[type])}
                        loading={monthlyPassSummary.loading}
                        showDonutChart={true}
                    />
                    <PermitSummaryCard
                        title="Recharge"
                        data={monthlyPassSummary.data}
                        getValue={data => data.rechargeCount}
                        getAmount={data => data.rechargeAmount ? `₹ ${data.rechargeAmount.toFixed(2)}` : `₹ 0`}
                        getDistributedLabels={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].rechargeCount > 0).map(type => data.vehicleTypes[type].name)}
                        getDistributedValues={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].rechargeCount > 0).map(type => data.vehicleTypes[type].rechargeCount)}
                        getDistributedAmount={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].rechargeAmount > 0).map(type => data.vehicleTypes[type].rechargeAmount)}
                        getDistributedIcons={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].rechargeCount > 0).map(type => vehicleSvgs[type])}
                        loading={monthlyPassSummary.loading}
                        showDonutChart={true}
                    />
                </div>}

                <List
                    style={{ marginTop: 10 }}
                    filter={filter}
                    sort={{ field: 'log_time', order: 'DESC' }}
                    bulkActionButtons={false}
                    empty={false}
                    {...props}
                    exporter={false}
                    actions={false}
                    pagination={<CustomPagination setListData={(listData) => { listDataRef.current = listData }} />}
                >
                    {isSmallDevice ?
                        <SimpleList
                            leftIcon={row => <Avatar alt={row.vehicle_type_label} src={vehicleSvgs[row.vehicle_type]} style={{ padding: 4, width: 28, height: 28, marginTop: 8, marginRight: 10, overflow: "visible" }} />}
                            primaryText={record => `${hideVehicleNumber(record.vehicle_number.toUpperCase())} - ${hideName(record.name)}`}
                            secondaryText={record => {
                                return (<div>
                                    <div style={{ color: customTheme.palette.secondary.main }}>{record.parking_name}</div>
                                    {record.name && <div><span style={{ color: "#5a5a5a" }}>Name: </span>{hideVehicleNumber(record.name)}</div>}
                                    {record.mobile_number && <div><span style={{ color: "#5a5a5a" }}>Mobile No: </span>{hideMobileNumber(record.mobile_number)}</div>}
                                    {/* <div style={{ color: "#555" }}>{record.parking_name}</div> */}
                                    {record.log_type && <div><span style={{ color: "#5a5a5a" }}>Log Type: </span>{renderActionForMob(record["log_type"])}</div>}
                                    {record.log_time && <div><span style={{ color: "#5a5a5a" }}>Log Time: </span>{renderTime(record.log_time)}</div>}
                                    {record.price && record.price !== "" && !isNaN(record.price) && <div><span style={{ color: "#5a5a5a" }}>Price: </span>₹{parseFloat(record.price)}</div>}
                                </div>);
                            }}
                            linkType={false}
                            rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                        />
                        :
                        <Datagrid className={!viewOnly ? 'monthlyPassPaymentsDataGrid' : ''} component={ScrollableTable}>
                            <FunctionField label="Vehicle number" render={record => record && record.vehicle_number && hideVehicleNumber(record.vehicle_number.toUpperCase())} />
                            <FunctionField label="Vehicle type" render={record => record && renderVehicleType(record)} />
                            <FunctionField source='name' label='Name' render={(record) => record && record.name ? hideName(record.name) : '-'} />
                            <FunctionField source="mobile_number" label="Mobile" render={record => record && record["mobile_number"] && record["mobile_number"] !== null ? hideMobileNumber(record.mobile_number) : "-"} />
                            <TextField source="parking_name" />
                            <FunctionField label="Price" render={(record) => record && <div style={{ textAlign: "center" }}>
                                <div className='fontWeightBold secondaryColor' style={{ fontSize: 12 }}>
                                    {renderAmount(record, "price")}
                                </div>
                                <div className="fontWeightBold" style={{ color: "#334D6E", backgroundColor: "#EBEFF2", fontSize: 10, borderRadius: 2 }}>
                                    {record.payment_mode ? record.payment_mode : "-"}
                                </div>
                            </div>} />
                            <FunctionField source="log_type" label="Log Type" render={record => record && renderAction(record["log_type"])} />
                            <FunctionField source="log_time" label="Log Time" render={record => record["log_time"] ? renderTime(record["log_time"]) : '-'} />
                            {!viewOnly && <FunctionField className="ListIconsContainerMonthlyPassPayments" render={record => record &&
								<div className="ListIcons">
									<div>
										{permissions === "admin" && <CustomDeleteButtonDashboardPath record={record} refresh={refresh} resourcePath={'v1/monthly-pass-log'} disabled={record.log_type !== 'RECHARGE'} />}
									</div>
								
								</div>
							} />}
                        </Datagrid>
                    }
                </List>
            </>}
        </div>
    );
};
